import { MonthlyInstallmentType } from '~domain/helper/premiums/installment/installment-types';

const keys = {
  padPayment: {
    flinksPayment: {
      default: {
        subtitle: 'Instantly set up your payments',
        title: 'Select Your Bank',
      },
      consent: {
        title: 'Connect to your institution',
        desc: 'YouSet uses Flinks to instantly set up automatic monthly payments from your bank account. Flinks will provide YouSet with:',
        itemName: 'Your name and contact information',
        itemAccount: 'Account information (eg. account/transit number and balance)',
        cancel: 'You can request to withdraw this connection at any time.',
        action: 'Continue',
      },
      error: {
        title: 'Something went wrong, please <0>click here</0> to try again!',
      },
      success: {
        title: 'Connection done! Click <0>Confirm</0> to complete your order.',
      },
      waitingForConnection: 'Waiting for Connection',
    },
    mainSubtitle: {
      monthly: 'Let’s set up automatic monthly payments from your chequing account.',
      yearly: 'Let’s set up a one time payment annually from your chequing account.',
    },
    mainTitle: 'Payment',
    manualPayment: {
      accountHolderName: 'Bank Account Holder Name',
      accountNumber: 'Account Number',
      helper: {
        accountNumberLegend: 'The second set (7-12 digits) is your <0>account number</0>.',
        bankAccountStatement: '<0>Bank account statement</0>',
        bankAccountStatementAccount: 'Your <0>account number</0> is a 7 to 12 digits number.',
        bankAccountStatementDescription:
          'Find these numbers on your account statement from your bank or your onlince account.',
        bankAccountStatementTransit: 'Your <0>transit number</0> is a 5 digits number.',
        specimenCheque: '<0>Cheque specimen</0>',
        title: 'How to find this info?',
        transitNumberLegend: 'The first (5 digits) is your <0>transit number</0>.',
      },
      institutionNumber: 'Your Bank',
      transitNumber: 'Transit Number',
    },
    manualPaymentOption: '<0>Manually enter bank details</0>',
    previousPolicyNumber: {
      car: 'Current Car Policy Number',
      home: 'Current Home Policy Number',
    },
    withCarrier: 'With {{0}}',
    prompts: {
      errorPrompt: {
        message: {
          payment:
            'Before confirming the transaction, you have to set up the payments from your chequing account. Click on <0>Select your bank</0> or <0>Manually enter bank details</0>.',
          previousPolicyNumber:
            'Before confirming the transaction, you have to enter your current policy number with {{0}}.',
        },
      },
    },
    secondarySubtitle_one:
      'In order to finalize the transaction, we need to know your current policy number with {{0}}. Please wait until we send you your new policy before cancelling.',
    secondarySubtitle_other:
      'In order to finalize the transaction, we need to know your current policy numbers with {{0}}. Please wait until we send you your new policies before cancelling.',
    security: 'Secure Payment Assured',
    paymentDetails: {
      title: 'Payment Details',
      monthly: {
        paymentDate: '1st payment on {{0}}',
        evenlyDistributed: {
          price: '{{0}} / month',
        },
        [MonthlyInstallmentType.OneMonthInAdvance]: {
          firstMonthPayment: 'First payment of <0>{{0}}</0>',
          subsequentMonthlyPayments: 'Then 10 payments of {{0}}',
        },
        [MonthlyInstallmentType.TwoMonthInAdvance]: {
          firstMonthPayment: 'First payment of <0>{{0}}</0>',
          subsequentMonthlyPayments: 'Then 9 payments of {{0}}',
        },
      },
      yearly: {
        paymentDate: 'Single payment on {{0}}',
        price: '{{0}}',
      },
      product: {
        car: 'Car Insurance',
        home: 'Home Insurance',
      },
    },
  },
};

export default keys;

export type TranslationKeys = typeof keys;
